<template>
  <div class="container">
    <h1>Kontakt</h1>
    <div class="flex-container-desktop">
      <div class="flex-item-desktop">
        <h2>Katharina Herda</h2>
        <p>Craniosacrale Energiebalance</p>
        <ul>
          <li>
            <address>
              Baumgarten 14<br />
              3512 Mautern
            </address>
          </li>
          <li>Telefon: <a href="tel:+436644319933">+43 (0)664 431 99 33</a></li>
          <li>Email: <a href="mailto:katharina@herda.at">katharina@herda.at</a></li>
        </ul>

        <p>Telefonzeiten - Ich rufe gerne zurück</p>

        <p>
          Mitglied der WKO NÖ
        </p>
    </div>

    <div class="flex-item-desktop">
      <img src="../assets/img//contact/kathi-mit-katze.jpg"  width="300" alt="Katharina Herda sitzt mit einer Katze am Schoß im Garten" />
    </div>
  </div>
    <h2>Copyright</h2>
    <p>Die Herausgeberin hält alle Rechte an den auf der Webseite verwendeten Fotos.</p>
    <p>Herzlichen Dank an die Fotografen!</p>
    <ul class="list">
      <li><a href="http://maxberg.at">Max Berg</a></li>
      <li>Bianca Herda</li>
      <li>u.A.</li>
    </ul>

    <h2>Quellenangabe</h2>
    <ul class="list-hyphen">
      <li>Icons im Bilderslider erstellt von <a href="https://www.flaticon.com/de/autoren/kiranshastry" title="Kiranshastry">Kiranshastry</a> from <a href="https://www.flaticon.com/de/" title="Flaticon">www.flaticon.com</a></li>
      <li>Das letzte Fest von Nicole Rinder, Florian Rauch</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Contact",
   metaInfo() {
        return { 
            title: "Kontakt - Katharina Herda",
            meta: [
                { name: 'description', content:  'Adresse, Telefonummer, Email - Rufen Sie mich gerne an oder schreiben Sie eine Email zur Terminvereinbarung'},
                { property: 'og:title', content: "Kontakt - Katharina Herda"},                
                { property: 'og:description', content: "Adresse, Telefonummer, Email - Rufen Sie mich gerne an oder schreiben Sie eine Email zur Terminvereinbarung"},
                { property: 'og:image', content: 'src/img/assets/contact/kathi-mit-katze.jpg'},
                { property: 'og:url', content: 'www.herda.at/kontakt'}
            ]
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue